import { FieldArray } from "formik";

import { FormikTextInput } from "@sso/components/Formik";
import { Currency, LicenceType, PricingRule, PricingRuleCreateRequest, PricingRuleKeys } from "@sso/types";
import { Flex } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

interface AddCurrencyRulesProps {
  rules: any[];
  licenceType: string;
  currency?: Currency;
  fieldAccessor: string;
}

const AddCurrencyRules = ({ rules, licenceType, currency, fieldAccessor }: AddCurrencyRulesProps) => {
  return (
    <FieldArray
      name={fieldAccessor}
      render={arrayHelpers =>
        rules.map((rule: PricingRuleCreateRequest, index) => {
          return (
            <div
              key={index}
              style={{
                display: rule.currencyCode === currency?.code ? "grid" : "none",
                gridTemplateColumns: licenceType == LicenceType.SINGLE_USER ? "1fr" : "1fr 1fr 1fr",
                margin: "0.5rem 0",
              }}
            >
              {licenceType !== LicenceType.SINGLE_USER && (
                <Flex margin="0 1rem 0 0" justify="flex-end" align="center">
                  <Typography>
                    {rule[PricingRuleKeys.MIN_RANGE]} {rule[PricingRuleKeys.MAX_RANGE] != null ? "-" : ""}{" "}
                    {rule[PricingRuleKeys.MAX_RANGE] ?? "or more"}
                  </Typography>{" "}
                </Flex>
              )}
              <Flex margin="0 0 0 0" width="100%" justify="flex-start" align="center">
                {rule?.currency?.symbol}
                <FormikTextInput
                  noMargin
                  name={`${fieldAccessor}[${index}].${PricingRuleKeys.PRICE}`}
                  type="number"
                  width={licenceType === LicenceType.SINGLE_USER ? "100%" : "100px"}
                />
              </Flex>
              {licenceType !== LicenceType.SINGLE_USER && (
                <Flex justify="flex-start" align="center">
                  <Typography>per {licenceType === LicenceType.CONCURRENT ? "user" : "request"}</Typography>
                </Flex>
              )}
            </div>
          );
        })
      }
    />
  );
};

export default AddCurrencyRules;
